import React from 'react';

import styled, { css } from 'styled-components';

import { theme, Illustration } from 'fpay-ui';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageNotFound = styled(Illustration)(
  css`
    margin-top: 30px;
    height: 192px;
  `
);

const ContainerText = styled.div`
  max-width: 550px;
  ${({ theme }) => theme.textTypes['Subtitle-1-w400']};
  line-height: 1.25;
  color: ${theme.colors.gray600};
  text-align: center;
  font-size: 14px;
  padding: 0 16px 0 16px;
  ${theme.breakpoint('md')} {
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: 1.43;
    text-align: center;
  }
`;

const ContainerTextTitle = styled.div`
  width: 100%;
  padding: 0 16px 0 16px;
  ${({ theme }) => theme.textTypes['Subtitle-1-w400']};
  line-height: 1.25;
  font-size: 18px;
  color: ${theme.colors.gray800};
  text-align: center;
  margin-bottom: 16px;
  ${theme.breakpoint('md')} {
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    font-size: 24px;
    line-height: 1.43;
    text-align: center;
  }
`;

const EmptyList = ({ title, subTitle }) => (
  <Container>
    <ImageNotFound name="no_search_result" alt="Sin Resultados" />
    <ContainerTextTitle>{title}</ContainerTextTitle>
    <ContainerText>{subTitle}</ContainerText>
  </Container>
);
export default EmptyList;
